// extracted by mini-css-extract-plugin
export default {"row":"AiModelRow_row__38DGD","cell":"AiModelRow_cell__Deokl","actions":"AiModelRow_actions__51RGy"};